import React from 'react';
import {
  AlertDialog,
  AlertDialogBackdrop,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
} from '@/components/gluestack/alert-dialog';
import { Text } from '@/components/gluestack/text';
import { Button, ButtonText } from '@/components/gluestack/button';
import { VERSION_WITH_BUILD } from '@/constants/version';
import { useTranslation } from 'react-i18next';

import { HStack } from '@/components/gluestack/hstack';
import { VStack } from '@/components/gluestack/vstack';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import { ComputerPhoneSyncIcon } from '@hugeicons-pro/core-solid-rounded';

export interface IAboutDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AboutDialog({ isOpen, onClose }: IAboutDialogProps) {
  const { t } = useTranslation();
  return (
    <AlertDialog isOpen={isOpen} onClose={onClose} size="sm">
      <AlertDialogBackdrop onPress={onClose} />
      <AlertDialogContent>
        <AlertDialogHeader>
          <Text size="lg" className="font-semibold">{t('settings.about.title')}</Text>
          <AlertDialogCloseButton />
        </AlertDialogHeader>
        <AlertDialogBody>
          <HStack className="my-8 items-center gap-4">
            <HugeIconsWrapper
              icon={ComputerPhoneSyncIcon}
              size={56}
              className="color-neutral-400"
            />

            <VStack className="flex-1 gap-1">
              <Text className="text-typography-700">
                {t('settings.about.version')}: <Text className="font-semibold">{VERSION_WITH_BUILD}</Text>
              </Text>
              <Text size="sm" className="text-typography-600">© Grokio Communities. All rights reserved.</Text>
            </VStack>
          </HStack>
        </AlertDialogBody>
        <AlertDialogFooter>
          {/* Neutral on purpose: this Grokio-meta dialog inherits whatever
              theme is ambient, so nothing in it may carry community branding. */}
          <Button action="neutral" onPress={onClose}>
            <ButtonText>{t('common.continue')}</ButtonText>
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default AboutDialog;
